import { regularServicedSitePictures } from "../regularServicedSitePictures";
import { cabinPictures } from "../cabinPictures";
import { unservicedSitePictures } from "../unservicedSitePictures";
import { premiumServicedSitePictures } from "../premiumServicedSitePictures";
import { fiftyAmpSitePictures } from "../fiftyAmpSitePictures";
import {
  IconButton,
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Icon,
} from "@mui/material";
import tent from "../tent.jpg";
import pic1 from "../regular_69.webp";
import red from "../red2.png";
import fiftyAmpPic from "../50amp-pic.png";
import cabinPic from "../Cabin-11.webp";
import unservicedSitePic from "../Site-46.webp";
import servicedSitePic from "../Q.jpg";
import premiumServicedSitePic from "../37.webp";
import { Link } from "react-router-dom";
import { useLayoutEffect, useState } from "react";
import { Close } from "@mui/icons-material";
import { SitePicsDialog } from "./SitePicsDialog";

export const Sites = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  });

  //state variables for the pictures dialog
  const [dialogIsOpen, setDialogIsOpen] = useState(false);
  const [dialogTitle, setDialogTitle] = useState("");
  const [sitePicsForDialog, setSitePicsForDialog] = useState(
    unservicedSitePictures
  );
  const [currentSitePictureIndex, setCurrentSitePictureIndex] = useState(0);

  return (
    <div className="homepage-cards-container">
      <div>
        {/* the pictures dialog that shows the site pictures when any "PICTURES" button gets clicked */}
        <SitePicsDialog
          open={dialogIsOpen}
          setDialogIsOpen={setDialogIsOpen}
          title={dialogTitle}
          pics={sitePicsForDialog}
          currentSitePictureIndex={currentSitePictureIndex}
          setCurrentSitePictureIndex={setCurrentSitePictureIndex}
        />

        {/* the cards for each site type */}
        <Card className="card">
          <CardMedia component="img" height="260" image={unservicedSitePic} />
          {/* <img src={red} height='225em'></img> */}
          <div className="cardContent">
            <Typography variant="h5">Unserviced Campsites</Typography>
            <Typography color="text.secondary">Summer: $54 / Night</Typography>
            <Typography color="text.secondary" sx={{ marginBottom: "0.15em" }}>
              Spring / Fall: $44 / Night
            </Typography>
            <Typography>
              For people looking to truly unplug, our unserviced sites have no
              water or power outlet on the site. These sites are within a 2
              minute walk of water taps where you can get drinking water or wash
              your dishes. If you do need to charge your phone, there are
              outlets in our bathrooms.
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/book" state={{ siteType: "Unserviced" }}>
                <Button
                  onClick={() => window.scrollTo(0, 0)}
                  variant="outlined"
                >
                  {" "}
                  Book
                </Button>
              </Link>
              <Button
                variant="outlined"
                onClick={() => {
                  setDialogIsOpen(true);
                  setDialogTitle("Unserviced Sites");
                  setSitePicsForDialog(unservicedSitePictures);
                  setCurrentSitePictureIndex(0);
                }}
              >
                Pictures
              </Button>
            </CardActions>
          </div>
        </Card>
      </div>

      <div>
        <Card className="card">
          {/* <img src={tent} height='225em'></img> */}
          <CardMedia component="img" height="260" image={servicedSitePic} />
          <div className="cardContent">
            <Typography variant="h5">
              Regular Serviced Campsites
            </Typography>
            <Typography color="text.secondary">Summer: $66 / Night</Typography>
            <Typography color="text.secondary" sx={{ marginBottom: "0.15em" }}>
              Spring / Fall: $54 / Night
            </Typography>
            <Typography>
              Regular serviced sites are suitable for camper trucks/vans, small
              trailers (22' and under), motorhomes (25' and under), or tenters
              wanting electricity. Our regular serviced sites have a water tap
              and 15/30 Amp power. This means there is a post on the site that
              has both a normal 15 Amp outlet like you'd find in your house, and
              a 30 Amp outlet for trailers to plug into. The main difference
              between regular serviced and premium serviced sites is that
              premium serviced sites are for campers who want more space.
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/book" state={{ siteType: "Regular Serviced" }}>
                <Button
                  onClick={() => window.scrollTo(0, 0)}
                  variant="outlined"
                >
                  {" "}
                  Book
                </Button>
              </Link>
              <Button
                variant="outlined"
                onClick={() => {
                  setDialogIsOpen(true);
                  setDialogTitle("Regular Serviced Sites");
                  setSitePicsForDialog(regularServicedSitePictures);
                  setCurrentSitePictureIndex(0);
                }}
              >
                Pictures
              </Button>
            </CardActions>
          </div>
        </Card>
      </div>

      <div>
        <Card className="card">
          <CardMedia
            component="img"
            height="260"
            image={premiumServicedSitePic}
          />
          {/* <img src={tent} height='225em'></img> */}
          <div className="cardContent">
            <Typography variant="h5">
              Premium Serviced Campsites
            </Typography>
            <Typography color="text.secondary">Summer: $77 / Night</Typography>
            <Typography color="text.secondary" sx={{ marginBottom: "0.15em" }}>
              Spring / Fall: $64 / Night
            </Typography>
            <Typography>
              The main difference between our regular sites and premium sites is
              that premium sites are more spacious and can fit larger trailers
              and motorhomes. Smaller units are also welcome to book these
              larger sites if they prefer having extra space on site. Some of
              these sites have a crushed stone pad surrounded by grass, however,
              most are wooded with a fine gravel base. Our premium serviced
              sites have a water tap and 15/30 Amp power. This means there is a
              post on the site that has both a normal 15 Amp outlet like you'd
              find in your house, and a 30 Amp outlet for trailers to plug into.
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/book" state={{ siteType: "Premium Serviced" }}>
                <Button
                  onClick={() => window.scrollTo(0, 0)}
                  variant="outlined"
                >
                  Book
                </Button>
              </Link>
              <Button
                variant="outlined"
                onClick={() => {
                  setDialogIsOpen(true);
                  setDialogTitle("Premium Serviced Sites");
                  setSitePicsForDialog(premiumServicedSitePictures);
                  setCurrentSitePictureIndex(0);
                }}
              >
                Pictures
              </Button>
            </CardActions>
          </div>
        </Card>
      </div>

      <div>
        <Card className="card">
          <CardMedia component="img" height="260" image={fiftyAmpPic} />

          {/* <img src={fiftyAmpPic} height='220em'></img> */}
          <div className="cardContent">
            <Typography variant="h5">50 Amp Campsites</Typography>
            <Typography color="text.secondary">Summer: $80 / Night</Typography>
            <Typography color="text.secondary" sx={{ marginBottom: "0.15em" }}>
              Spring / Fall: $67 / Night
            </Typography>
            <Typography>
              Premium serviced 50 amp sites provide 50 amp 220-volt electrical
              service and water hookup onsite, accommodating larger trailers or
              motorhomes up to 40'. They also have 15/30 amp 110 volt
              electricity connections. All five of our premium serviced 50 amp
              sites have a crushed stone trailer pad with a fire pit and picnic
              table provided.
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/book" state={{ siteType: "50 Amp" }}>
                <Button
                  onClick={() => window.scrollTo(0, 0)}
                  variant="outlined"
                >
                  Book
                </Button>
              </Link>
              <Button
                variant="outlined"
                onClick={() => {
                  setDialogIsOpen(true);
                  setDialogTitle("50 Amp Sites");
                  setSitePicsForDialog(fiftyAmpSitePictures);
                  setCurrentSitePictureIndex(0);
                }}
              >
                Pictures
              </Button>
            </CardActions>
          </div>
        </Card>
      </div>

      <div>
        <Card className="card">
          {/* <img src={tent} height='225em'></img> */}
          <CardMedia component="img" height="260" image={cabinPic} />
          <div className="cardContent">
            <Typography variant="h5">Cabins</Typography>
            <Typography color="text.secondary">Summer: $112 / Night</Typography>
            <Typography color="text.secondary" sx={{ marginBottom: "0.15em" }}>
              Spring / Fall: $91 / Night
            </Typography>
            <Typography>
              We have cabins that comfortably sleep up to 4 people (one double
              bed and one set of single bunk beds) and cabins meant for 2 people
              (one queen bed). Each camping cabin sits on its own site with a
              picnic table and campfire pit, a door that locks, lights (inside
              and out), 15 Amp electrical service with heater, and a water tap
              at the outside front corner of the cabin.
            </Typography>
            <CardActions sx={{ paddingLeft: "0" }}>
              <Link to="/book" state={{ siteType: "Cabin" }}>
                <Button
                  onClick={() => window.scrollTo(0, 0)}
                  variant="outlined"
                >
                  Book
                </Button>
              </Link>
              <Button
                variant="outlined"
                onClick={() => {
                  setDialogIsOpen(true);
                  setDialogTitle("Cabins");
                  setSitePicsForDialog(cabinPictures);
                  setCurrentSitePictureIndex(0);
                }}
              >
                Pictures
              </Button>
            </CardActions>
          </div>
        </Card>
      </div>
    </div>
  );
};
